export default __webpack_public_path__ + "static/media/Logo.fa6e6669.svg";